// src/components/icons/AllVoicedIcons.jsx

// icones

// escollir-les i importar-les d'aquí https://react-icons.github.io/react-icons/

// Per descarregar-les:
// FA https://fontawesome.com/icons
// FI https://feathericons.com/
// LU https://lucide.dev/
// PI https://github.com/phosphor-icons/core
// BS https://github.com/twbs/icons
// TB https://github.com/tabler/tabler-icons
// MD http://google.github.io/material-design-icons/
// AI https://github.com/ant-design/ant-design-icons
// IM https://github.com/Keyamoon/IcoMoon-Free
// GR https://github.com/grommet/grommet-icons
// RI https://github.com/Remix-Design/RemixIcon

// Si les vull fer servir per la newsletter, s'han de baixar en svg, convertir a png amb fons transparent 
// i posar a public/images/icons

// src/components/icons/AllVoicedIcons.jsx

import { FaRegTrashAlt, FaIcons, FaMusic, FaWhatsapp, FaLaptop, FaPaintBrush, FaRegArrowAltCircleLeft, FaOrcid, FaRegHeart, FaRegChartBar, FaRegComments, FaChalkboardTeacher, FaRegClipboard, FaHandHoldingHeart, FaRegCalendarAlt, FaRegLightbulb, FaFacebookSquare, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { FaQuoteLeft, FaQuoteRight, FaHeart, FaInbox, FaTags, FaLink, FaGraduationCap, FaHeartPulse, FaRegClock, FaEarListen, FaMagnifyingGlassChart, FaCheck, FaSliders, FaRegCopy } from "react-icons/fa6";
import { LuLibrary, LuShare2, LuScrollText, LuInfo, LuNewspaper, LuVote, LuBrain, LuRepeat, LuHeartHandshake, LuUser, LuUserPlus, LuUsers, LuSend, LuMic, LuMail, LuLanguages, LuTrophy, LuRocket, LuGlobe, LuFlaskConical, LuMicroscope, LuTimer, LuLock, LuLockOpen, LuListFilter, LuCircleHelp, LuMaximize, LuMinimize } from 'react-icons/lu';
import { FiEye, FiSettings, FiLogOut, FiLogIn, FiAlertTriangle, FiBookOpen, FiEdit3, FiShoppingCart, FiTarget } from 'react-icons/fi';
import { PiToolbox, PiWaveform, PiLinktreeLogoFill, PiMagnifyingGlassBold } from "react-icons/pi";
import { BsPinAngle, BsPinAngleFill, BsPlayCircle, BsStopCircle, BsRecordCircle, BsMegaphone } from "react-icons/bs";
import { MdAdd, MdScreenRotation, MdConstruction, MdOutlineSpaceDashboard, MdOutlineDashboardCustomize } from "react-icons/md";
import { ImBooks, ImLocation } from "react-icons/im";
import { GrHomeRounded, GrGrow, GrMenu, GrClose, GrCheckbox, GrCheckboxSelected, GrDocumentText } from "react-icons/gr";
import { RiUserVoiceLine, RiShieldStarLine, RiMagicLine } from "react-icons/ri";
import { TbRulerMeasure, TbDeviceGamepad3, TbSitemap } from "react-icons/tb";
import { IoFootstepsOutline, IoSparklesSharp } from "react-icons/io5";
import { SiResearchgate } from "react-icons/si";

// 🧭 Mapeig d’icones per nom
export const ICON_MAP = {
  alert: FiAlertTriangle,
  add: MdAdd,
  analytics: FaRegChartBar,
  arrow: FaRegArrowAltCircleLeft,
  assessment: FaRegClipboard,
  badge: RiShieldStarLine,
  book: FiBookOpen,
  books: ImBooks,
  brain: LuBrain,
  calendar: FaRegCalendarAlt,
  check: FaCheck,
  checkbox: GrCheckbox,
  checkboxSelected: GrCheckboxSelected,
  clock: FaRegClock,
  close: GrClose,
  comments: FaRegComments,
  concept: TbSitemap,
  construction: MdConstruction,
  copy: FaRegCopy,
  custom: RiMagicLine,
  customize: MdOutlineDashboardCustomize,
  dashboard: MdOutlineSpaceDashboard,
  document: GrDocumentText,
  edit: FiEdit3,
  eye: FiEye,
  facebook: FaFacebookSquare,
  filter: LuListFilter,
  flask: LuFlaskConical,
  game: TbDeviceGamepad3,
  globe: LuGlobe,
  graduationCap: FaGraduationCap,
  grow: GrGrow,
  health: FaHeartPulse,
  help: LuCircleHelp,
  heart1: FaRegHeart,
  heart2: FaHeart,
  heartHandsShake: LuHeartHandshake,
  home: GrHomeRounded,
  icons:FaIcons,
  inbox: FaInbox,
  info: LuInfo,
  instagram: FaInstagram,
  languages: LuLanguages,
  laptop: FaLaptop,
  learn: IoFootstepsOutline,
  library: LuLibrary,
  lightbulb: FaRegLightbulb,
  link: FaLink,
  linkedin: FaLinkedin,
  linktree: PiLinktreeLogoFill,
  listen: FaEarListen,
  location: ImLocation,
  lock: LuLock,
  lockOpen: LuLockOpen,
  login: FiLogIn,
  logout: FiLogOut,
  magnifyingGlass: PiMagnifyingGlassBold,
  magnifyingGlassChart: FaMagnifyingGlassChart,
  mail: LuMail,
  maximize: LuMaximize,
  measure: TbRulerMeasure,
  megaphone: BsMegaphone,
  menu: GrMenu,
  mic: LuMic,
  music: FaMusic,
  minimize: LuMinimize,
  newsletter: LuNewspaper,
  orcid: FaOrcid,
  paintbrush: FaPaintBrush,
  pin1: BsPinAngle,
  pin2: BsPinAngleFill,
  play: BsPlayCircle,
  quoteLeft: FaQuoteLeft,
  quoteRight: FaQuoteRight,
  record: BsRecordCircle,
  repeat: LuRepeat,
  research: LuMicroscope,
  researchGate: SiResearchgate,
  rocket: LuRocket,
  screenRotation: MdScreenRotation,
  scrolltext: LuScrollText,
  send: LuSend,
  settings: FiSettings,
  share: LuShare2,
  shop: FiShoppingCart,
  signup: LuUserPlus,
  sliders: FaSliders,
  sparkles: IoSparklesSharp,
  stop: BsStopCircle,
  support: FaHandHoldingHeart,
  tags: FaTags,
  target: FiTarget,
  teacher: FaChalkboardTeacher,
  team: LuUsers,
  timer: LuTimer,
  toolbox: PiToolbox,
  trash: FaRegTrashAlt,
  trophy: LuTrophy,
  user: LuUser,
  voice: RiUserVoiceLine,
  vote: LuVote,
  wave: PiWaveform,
  whatsapp: FaWhatsapp,

  // 🔹 icones pròpies (SVG / PNG)
  isotypePositive: {
    type: 'image',
    src: '/images/logo/isotype-positive.svg',
  },
  isotypeNegative: {
    type: 'image',
    src: '/images/logo/isotype-negative.svg',
  },
    isotypeSilver: {
    type: 'image',
    src: '/images/logo/isotype-silver.svg',
  },
    isotypeGold: {
    type: 'image',
    src: '/images/logo/isotype-gold.svg',
  },
    isotypeBlack: {
    type: 'image',
    src: '/images/logo/isotype-black.svg',
  },
};

// 🎨 Component genèric
const AVIcon = ({
  icon,
  size = 28,
  color,
  className = '',
  alt = '',
  showAlert,   
  ...props
}) => {

  const IconEntry = ICON_MAP[icon];

  if (!IconEntry) {
    console.warn(`⚠️ Icon "${icon}" not found in AllVoicedIcons.`);
    return (
      <span style={{ color: '#999', fontSize: size, fontWeight: 'bold' }}>?</span>
    );
  }

  // 🖼️ Icona basada en imatge (SVG / PNG)
  if (typeof IconEntry === 'object' && IconEntry.type === 'image') {
    return (
      <img
        src={IconEntry.src}
        alt={alt || icon}
        className={`av-icon av-icon-image ${className}`}
        style={{ width: size, height: 'auto' }}
        {...props}
      />
    );
  }

  // 🎧 Icona React
  const IconComponent = IconEntry;

  return (
    <IconComponent
      size={size}
      {...(color ? { color } : {})}
      className={`av-icon ${className}`}
      {...props}
    />
  );
};

export default AVIcon;
